import cx from "classnames";
import styles from "./buttonToggle.module.scss";

interface ButtonToggleParams {
  onTabChange: (val: string) => void;
  options: [string, string];
  activeTab: string;
}

export default function ButtonToggle({
  onTabChange,
  options,
  activeTab,
}: ButtonToggleParams) {
  return (
    <div className={styles.container}>
      <button
        className={cx(activeTab === options[0] && styles.active)}
        type="button"
        onClick={() => {
          onTabChange(options[0]);
        }}
      >
        {options[0]}
      </button>
      <button
        className={cx(activeTab === options[1] && styles.active)}
        type="button"
        onClick={() => {
          onTabChange(options[1]);
        }}
      >
        {options[1]}
      </button>
    </div>
  );
}
